import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { CALENDAR_Z_INDICES } from '../../../constants';

const BADGE_HEIGHT = 20;
const BADGE_TOP_OFFSET = 7;
const LINE_TOP_OFFSET = 1;

interface Props {
  gridColumn: string;
  rowNumber: number;
  label: string;
  color?: string; // optional color for the current time indicator line and badge
}

export const TimeIndicator = ({ gridColumn, rowNumber, label, color = theme.colors.primary50 }: Props) => {
  const lineGridRow = `${Math.max(LINE_TOP_OFFSET, rowNumber)}/ span 1`;
  const badgeGridRow = `${Math.max(BADGE_TOP_OFFSET, rowNumber)}/ span 1`;

  return (
    <>
      <div
        data-time-indicator-line
        css={lineContainerStyle}
        style={{ gridColumn, gridRow: lineGridRow, border: `1px solid ${color}`, height: 1 }}
      />
      <div data-time-indicator-badge css={badgeContainerStyle} style={{ gridColumn, gridRow: badgeGridRow }}>
        <div
          css={badgeStyle}
          style={{ borderRadius: rowNumber < BADGE_TOP_OFFSET ? '4px 0 4px 4px' : '4px', backgroundColor: color }}
        >
          <Text color='white' textAlign='center' size='small' weight='bold'>
            {label}
          </Text>
        </div>
      </div>
    </>
  );
};

const lineContainerStyle = css({
  position: 'relative',
  zIndex: CALENDAR_Z_INDICES.currentTimeIndicatorLine,
  pointerEvents: 'none',
  boxShadow: theme.shadows.light,
});

const badgeContainerStyle = css({
  zIndex: CALENDAR_Z_INDICES.currentTimeIndicatorBadge,
  pointerEvents: 'none',
});

const badgeStyle = css({
  boxShadow: theme.shadows.light,
  '--badge-width': 'var(--group-separator-width)',
  borderRadius: theme.borderRadius.medium,
  position: 'sticky',
  left: `calc(var(--time-column-width) - var(--badge-width))`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'var(--badge-width)',
  height: BADGE_HEIGHT,
  marginTop: `calc(-${BADGE_HEIGHT / 2}px)`,
  marginLeft: `calc(-1 * var(--badge-width))`,
});
